/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  '@atlassian/edition-awareness.button.addPaymentDetails': '新增付款詳細資料',
  '@atlassian/edition-awareness.button.automation-limits-breached': '已達到上限',
  '@atlassian/edition-awareness.button.automation-near-limit': '接近上限',
  '@atlassian/edition-awareness.button.choose-plans': '選擇方案',
  '@atlassian/edition-awareness.button.collection.addPaymentDetails': '新增付款詳細資料',
  '@atlassian/edition-awareness.button.collection.daysLeft':
    '{trialDaysLeft, plural, other {剩餘 {trialDaysLeft,number} 天}}',
  '@atlassian/edition-awareness.button.collection.upgrade': '升級',
  '@atlassian/edition-awareness.button.daysLeft': '{trialDaysLeft, plural, other {剩餘 {trialDaysLeft,number} 天}}',
  '@atlassian/edition-awareness.button.education-offer': '教育折扣',
  '@atlassian/edition-awareness.button.explore-edition':
    '{edition, select, premium {探索 Premium} standard {探索 Standard} other {探索試用}}',
  '@atlassian/edition-awareness.button.limited-users-left':
    '{product, select, jpd {只剩下幾位建立者名額} jsm {只剩下幾位客服人員名額} jira {只剩下幾位使用者名額} confluence {只剩下幾位使用者名額} other {只剩下幾位使用者名額}}',
  '@atlassian/edition-awareness.button.limited-users-left-content-adjustment':
    '{product, select, jpd {剩下 1 位建立者} jsm {剩下 1 位客服人員} other {剩下 1 位使用者}}',
  '@atlassian/edition-awareness.button.no-users-left':
    '{product, select, jpd {沒有剩餘的建立者名額} jsm {沒有剩餘的客服人員名額} jira {沒有剩餘的使用者名額} confluence {沒有剩餘的使用者名額} other {沒有剩餘的使用者名額}}',
  '@atlassian/edition-awareness.button.no-users-left-content-adjustment':
    '{product, select, jpd {沒有剩餘的建立者名額} jsm {沒有剩餘的客服人員名額} other {沒有剩餘的使用者名額}}',
  '@atlassian/edition-awareness.button.premium-trial': 'Premium 方案試用',
  '@atlassian/edition-awareness.button.see-plans': '查看方案',
  '@atlassian/edition-awareness.button.see-plans.cbrt': '查看方案',
  '@atlassian/edition-awareness.button.standard-trial': 'Standard 方案試用',
  '@atlassian/edition-awareness.button.storage-hard-limit': '儲存空間已滿',
  '@atlassian/edition-awareness.button.upgrade': '升級',
  '@atlassian/edition-awareness.button.upgrade.standard-to-premium': '升級',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.approaching-limits.subtitle':
    '{automation_limit_runs_free, plural, other {自動化在每月執行 {automation_limit_runs_free} 次後，會停止執行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.approaching-limits.title':
    '{automation_limit_runs_free, plural, other {您執行了 {automations_used} 次自動化，總共有 {automation_limit_runs_free} 次}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.automations-breached-title':
    '您已用完自動化執行次數 - 請升級以獲得更多',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.breached-limits.breached-subtitle':
    '您的自動化直到下個月才能執行',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.breached-limits.title': '你已達到上限！',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.dismiss': '關閉',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.free-limit': 'Free 方案上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.free-limit-value':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free,number} 次執行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.automation-benefits':
    '自動執行重複的任務，以節省時間',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.more-automations':
    '使用 Standard 方案，額外取得 {automation_runs_standard_comparison} 倍的執行次數額度',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-features.unlimited-users':
    '解鎖不限數量的使用者額度、額外安全性等',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-limit': 'Standard 方案上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.standard-limit-value':
    '{automation_limit_runs_standard, plural, other {{automation_limit_runs_standard,number} 次執行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.text.automation-limits-reset':
    '您的執行次數每月都會重設。',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.text.automation-limits-reset-with-manage-automations':
    '您的執行次數每月都會重設。<Link>管理自動化</Link>',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.title': '升級以不間段地執行自動化',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-free.upgrade': '升級',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.add-payment-details': '新增付款詳細資料',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.dismiss': '關閉',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.free-limit': 'Free 方案上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.free-limit-value':
    '{automation_limit_runs_free, plural, other {{automation_limit_runs_free,number} 次執行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.modal-title': '新增付款以讓自動化保持執行',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.automation-benefits':
    '進階管理員控管和權限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.more-automations':
    '{automation_limit_standard_comparison, plural, other {每月自動化執行額度多 {automation_limit_standard_comparison} 倍}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-features.unlimited-users':
    '保持不限數量的使用者額度、額外安全性等',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-limit': 'Standard 方案上限',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.standard-limit-value':
    '{automation_limit_runs_standard, plural, other {{automation_limit_runs_standard,number} 次執行}}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-add-payment':
    'Free 方案所獲得的自動化執行次數較少。在試用期於 {endDate,date,medium}結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-add-payment-without-date':
    'Free 方案所獲得的自動化執行次數較少。在試用期結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.text.automation-limits-list-features':
    '不要丟失 Standard 方案中的這些功能：',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.title':
    'Free 方案所獲得的執行次數會少 {automation_free_limit_percentage_comparison,number,::percent}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal-standard.title-not-breached':
    '降級意味著執行次數會少 {automation_free_limit_percentage_comparison,number,::percent}',
  '@atlassian/edition-awareness.dialog.automation-limits-modal.approaching-limits.projection-title':
    '預計您每個月會使用 {projection} 次自動化',
  '@atlassian/edition-awareness.dialog.automation-limits-modal.approaching-limits.title':
    '持續升級，以便能持續大規模地自動化',
  '@atlassian/edition-awareness.dialog.collection-popup.twc.add-payment-details.content':
    '新增付款詳細資料以持續使用 {edition} 方案。',
  '@atlassian/edition-awareness.dialog.collection-popup.twc.add-payment-details.description':
    '您的試用已結束。我們提供您額外 12 天的時間，可保有所有的 {edition} 功能。',
  '@atlassian/edition-awareness.dialog.collection-popup.twc.add-payment-details.heading': 'Teamwork Collection 試用',
  '@atlassian/edition-awareness.dialog.collection-popup.twc.change-plan-with-pde.content': '結束試用並變更方案',
  '@atlassian/edition-awareness.dialog.collection-popup.twc.change-plan-with-pde.description':
    '當試用在 {trialEndDate} 結束時，系統會向您收取 {edition} 費用。',
  '@atlassian/edition-awareness.dialog.collection-popup.twc.change-plan-with-pde.heading': 'Teamwork Collection 試用',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.apply-description':
    '立即申請，一旦獲得核准，您的折扣將自動套用至所選方案。獲取如下功能：',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.apply-for-discount': '申請折扣',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.compare-plans': '比較方案',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.dont-show-again': '不再對我顯示此內容',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.hub':
    '最新消息、更新內容和資源的中心',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.users':
    '不限數量的使用者額度，以輕鬆新增協作者',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.confluence.whiteboards':
    '不限數量的白板額度，用於群組構想',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.grammar': '文法與寫作助理',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.security':
    '進階安全性和使用情況深入解析',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jira.users':
    '不限數量的使用者額度，以輕鬆新增協作者',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.security': '進階安全性和使用情況深入解析',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.users':
    '不限數量的使用者額度，以輕鬆新增協作者',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jpd.views': '唯讀檢視以分享後續的計畫',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.agents':
    '用於例行要求的自動化服務客服人員',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.security': '進階安全性和使用情況深入解析',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.feature.jsm.users':
    '最多 20,000 位協助客服人員和不限數量的客戶額度',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.illustration.alt':
    '老師、學生等：申請高達 75% 的折扣。',
  '@atlassian/edition-awareness.dialog.educational-discount-modal.title': '獲得教育折扣 📚',
  '@atlassian/edition-awareness.dialog.feature-onboarding.call-to-action.try-now': '立即試用',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.auto-open': '您想先嘗試什麼？',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.automation': '自動化',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.guest-access2': '訪客存取權',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.mission-control2': '任務控制',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.premium-page-permissions2': '頁面權限',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.standard-page-permissions2': '頁面權限',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.unlimited-whiteboards2': '不限數量的白板',
  '@atlassian/edition-awareness.dialog.feature-onboarding.heading.without-auto-open2': '請在試用期結束前，試試這些功能',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subheading.automation': '簡化重複任務',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subheading.guest-access2': '與外部客戶分享唯讀頁面',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subheading.mission-control': '在單一位置獲得深入解析',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subheading.premium-page-permissions':
    '控管誰可以檢視、編輯並留言',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subheading.standard-page-permissions':
    '控管誰可以檢視、編輯並留言',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subheading.unlimited-whiteboards':
    '在無限的畫布上進行腦力激盪或建立流程',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subtitle.auto-open':
    '您的新方案包含無限制的使用者額度和儲存空間。',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subtitle.with-change-plan-link2':
    '您的試用將於 {trialEndDate} 結束。<change-plan-link>探索所有方案</change-plan-link>',
  '@atlassian/edition-awareness.dialog.feature-onboarding.subtitle.without-change-plan-link2':
    '您的試用將於 {trialEndDate} 結束。',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.free.heading': 'Free 的限制：',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.free.storage': '2 GB 儲存空間',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.free.users': '多達 10 位使用者',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.free.whiteboards':
    '每位使用者最多可有 3 個作用中的白板',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.premium.heading':
    'Standard 方案中的所有功能，外加：',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.premium.whiteboards': '不限數量的白板',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.admin':
    '進階管理員控管和分析',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.ai':
    'Rovo (AI) 搜尋、聊天和客服人員',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.automation':
    '每月 1,000 次自動化執行',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.calendar': '團隊行事曆',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.data-storage':
    '選擇您的資料儲存位置',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.heading':
    'Free 方案中的所有功能，外加：',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.insights-permissions':
    '深入解析和權限',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.read-only':
    '與任何人分享唯讀檢視畫面',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.storage': '無限儲存空間',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.support':
    '重要問題的全天候支援',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition-modal.inclusions.standard.users': '不限數量的使用者',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.footer':
    '您可以隨時取消。我們會在試用期結束的三天前提醒您。',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.footer-link': '檢視所有功能',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.cta': '目前的方案',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.description': '從基礎開始',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.heading': '您使用的是 Free 版',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.annotation-storage-limit-met':
    '已全滿',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.annotation-storage-limit-not-met':
    '剩餘 {gigabytesRemaining} GB',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.annotation-user-limit':
    '已新增 {licensedUsers}/{userLimit} 個',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.title-storage-limit-met':
    '儲存空間已滿',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.title-storage-limit-not-met':
    '儲存空間幾乎用盡',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.title-user-limit-met':
    '沒有剩餘的使用者名額',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.free.section-message.title-user-limit-not-met':
    '使用者名額幾乎用盡',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.premium.cta': '可免費試用 30 天',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.premium.description':
    '打破孤島與連結團隊之間的工作',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.premium.heading': 'Premium',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.premium.section-message.info':
    'Standard 方案中的所有內容，外加：',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.premium.section-message.title-default':
    '所有功能',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.premium.section-message.title-recommended':
    '完美選擇',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.recommended-header.personalised':
    '根據使用量建議',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.recommended-header.popular': '最熱門',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.cta': '免費試用 14 天',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.description':
    '加快團隊速度，而仍保有控制',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.heading': 'Standard',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.section-message.info-storage-limit':
    '可新增檔案、照片等更多內容的空間',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.section-message.info-user-limit':
    '團隊成長的空間',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.section-message.title-default':
    '優質選擇',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.standard.section-message.title-recommended':
    '完美選擇',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.subtitle':
    '透過升級，您即可獲得不限數量的使用者額度、更多的儲存空間以新增相片和檔案，以及訪客存取權等等。',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.title-not-near-limits':
    '升級以充分利用 Confluence',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.title-storage-limit':
    '您的儲存空間幾乎用盡。升級以獲得更多儲存空間',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.title-storage-limit-reached':
    '您的儲存空間已用盡。升級以獲得更多儲存空間',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.title-user-limit':
    '您的 Free 方案使用者名額幾乎用盡。升級即可取得無限制的名額',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.confluence.title-user-limit-reached':
    '您已用完 Free 方案使用者的名額。升級即可取得無限制的名額',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag.action': '重新整理',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.entrypoint.flag.title':
    '我們無法取得您的計畫詳細資料。',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.refresh-link': '請重新整理，然後再試一次',
  '@atlassian/edition-awareness.dialog.free-choose-your-edition.upgrade-currently-unavailable':
    '目前無法升級，{refreshLink}',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-at-limit':
    '您已用完免費的使用者額度',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-get-everyone-in-one-tool':
    '讓所有人都能使用相同的工具',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.heading-near-limit': '升級以新增您的團隊',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.invited-users-count':
    '已邀請 {numberOfUsers} 位，總共有 {licensedUserLimit} 位',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.maybe-later': '稍後再說',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.subtitle-for-premium':
    '開始免費試用 Premium 方案 30 天。可隨時取消，我們會在試用期結束前 3 天提醒您。',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.subtitle-for-standard':
    '開始免費試用 Standard 方案 14 天。可隨時取消，我們會在試用期結束前 3 天提醒您。',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.try-it-now': '立刻試用',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-gb-storage':
    '升級以獲得 {gbToBuy} GB 的儲存空間',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-unlimited-storage':
    '升級以獲得無限的儲存空間',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.upgrade-for-unlimited-users':
    '升級以獲得不限數量的使用者額度',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.user-limit-description-for-premium':
    '{licensedUserLimit, plural, other {如果您新增超過 {licensedUserLimit} 位使用者，您將自動升級}}',
  '@atlassian/edition-awareness.dialog.free-to-recommended-edition.confluence.user-limit-description-for-standard':
    '{licensedUserLimit, plural, other {如果邀請超過 {licensedUserLimit} 位使用者，將開始 Standard 方案的 14 天免費試用}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.continue': '稍後再說',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.creator-limits.creator-limits-capped-limit-description':
    '如果新增超過 3 位建立者，將自動開始試用',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.creator-limits.creator-limits-free-limit-description':
    'Free 方案的上限是 3 位建立者',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.creator-limits.no-creators-title':
    '沒有剩餘的免費建立者名額',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.heading': '升級即可取得不限數量的建立者名額',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.heading-at-limit': '您已達到上限，該升級了',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.standard-features.automation':
    '自動化執行多 2.5 倍',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.standard-features.buy-now-description':
    '升級至 Standard 方案，並使用進階功能擴展您的團隊，包括：',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.standard-features.start-trial-description':
    '開始免費試用 Standard 方案 14 天，以獲得進階功能。您可以隨時取消。將獲得：',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.standard-features.unlimited-agents':
    '不限數量的建立者',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.upgrade': '升級',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jpd.user-limits.leftover-users-title':
    '{leftoverUsers, plural, other {剩下 {leftoverUsers} 個建立者名額}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.agent-limits.agent-limits-capped-limit-description':
    '如果新增超過 3 位客服人員，將自動開始試用',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.agent-limits.agent-limits-free-limit-description':
    'Free 方案的上限是 3 位客服人員',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.agent-limits.no-agents-title':
    '沒有剩餘的免費客服人員名額',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.continue': '稍後再說',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.heading': '升級以取得不限數量的客服人員',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.heading-at-limit': '您已達到上限，該升級了',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.standard-features.automation': '自動化執行多 10 倍',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.standard-features.buy-now-description':
    '升級至 Standard 方案，並使用進階功能擴展您的團隊，包括：',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.standard-features.data-residency': '資料落地',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.standard-features.start-trial-description':
    '開始免費試用 Standard 方案 14 天，以獲得進階功能。您可以隨時取消。將獲得：',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.standard-features.unlimited-agents':
    '不限數量的客服人員額度',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.upgrade': '升級',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh-jsm.user-limits.leftover-users-title':
    '{leftoverUsers, plural, other {剩下 {leftoverUsers} 個客服人員名額}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.jpd.feature-security-compliance': '已發布檢視供分享',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.jpd.standard-features.project-roles': '自訂專案角色',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.jsm.standard-features.audit-logs': '稽核記錄',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.leftover-users-title':
    '{leftoverUsers, plural, other {剩餘 {leftoverUsers} 位免費使用者的額度}}',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.no-users-title': '沒有剩餘的免費使用者額度',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-auto-trial-description':
    '如果邀請超過 10 位使用者，將自動開始試用',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-free-limit-description':
    'Free 方案的上限是 10 位使用者',
  '@atlassian/edition-awareness.dialog.free-to-standard-refresh.user-limits.user-limits-title':
    '{licensedUserLimit, plural, other {已新增 {numberOfUsers} 位免費使用者，總共有 {licensedUserLimit} 位}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.description':
    '升級以獲得 {standardStorageLimit} GB 的儲存空間',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.title':
    '已使用 {storageUsed} GB，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-limits.title.aria':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-used.title':
    '已使用 {storageUsed} GB，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.storage-used.title.aria':
    '已使用 {storageUsed} GB，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.description':
    '升級以取得不限數量的使用者上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.description.near-limit':
    '{licensedUserLimit, plural, other {如果邀請超過 {licensedUserLimit} 位使用者，將開始 Standard 方案的 14 天免費試用}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.carousel.user-limits.title':
    '已邀請 {numberOfUsers} 位，總共有 {licensedUserLimit} 位',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.description':
    '開始免費試用 Standard 方案 14 天。可隨時取消，我們會在試用期結束前 3 天提醒您。',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.maybe-later': '稍後再說',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-at-limit': '您已用完免費的使用者額度',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-near-limit': '升級以新增您的團隊',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.title-not-near-limit': '讓所有人都能使用相同的工具',
  '@atlassian/edition-awareness.dialog.free-to-standard.confluence.try-now': '立刻試用',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.alt': '將附件新增至 Jira',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.increased-storage.title': '更高的儲存空間上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.anonymous-access.description':
    '為團隊以外的人員提供安全的存取權。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.anonymous-access.title':
    '匿名存取',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.support.description':
    '獲得 Atlassian 專家團隊的支援。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.support.title': '上班時間支援',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.title': 'Standard 方案功能',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.user-roles.description':
    '進一步控管哪些使用者可以存取不同的專案和動作。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.standard-features.user-roles.title':
    '使用者角色和權限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.description':
    '升級至 {standardStorageLimit} GB 的儲存空間以繼續附加檔案',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.title':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.storage-limits.title.aria':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.alt': '將使用者新增至 Jira',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.unlimited-users.title': '不限數量的使用者',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.user-limits.description':
    '{licensedUserLimit, plural, other {升級以取得不限數量的使用者額度。如果您新增超過 {licensedUserLimit} 位使用者，您將自動升級。}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.carousel.user-limits.title':
    '{licensedUserLimit, plural, other {您已邀請 {licensedUserLimit} 位使用者中的 {numberOfUsers} 位使用者}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.continue': '不需要提高上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.description':
    '您正在使用 Free 方案。取得 Standard 方案 14 天免費試用，以獲得不限數量的使用者額度和額外儲存空間等等。可以隨時取消。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.title': '升級至 Standard 方案',
  '@atlassian/edition-awareness.dialog.free-to-standard.jira.try-now': '立即試用',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.alt':
    '將附件新增至 Jira Product Discovery',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.increased-storage.title': '更高的儲存空間上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.custom-roles.description':
    '透過建立具有特定權限的自訂專案角色，進一步掌握細節。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.custom-roles.title':
    '自訂專案角色',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.data-residency.description':
    '選擇要託管資料的位置。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.data-residency.title':
    '資料落地',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.support.description':
    '獲得 Atlassian 專家團隊的支援。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.support.title': '上班時間支援',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.standard-features.title': 'Standard 方案功能',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.description':
    '升級至 {standardStorageLimit} GB 的儲存空間以繼續附加檔案',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.title':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.storage-limits.title.aria':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.alt':
    '將建立者新增至 Jira Product Discovery',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.unlimited-creators.title': '不限數量的建立者',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.user-limits.description':
    '{licensedUserLimit, plural, other {升級以取得不限數量的建立者。如果您新增超過 {licensedUserLimit} 位建立者，您將自動升級。}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.carousel.user-limits.title':
    '{licensedUserLimit, plural, other {您已邀請 {numberOfUsers} 位建立者，總共 {licensedUserLimit} 位}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.continue': '不需要提高上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.description':
    '您正在使用 Free 方案。免費試用 Standard 方案 14 天，以取得不限數量的建立者額度和額外儲存空間等等。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.title': '升級至 Standard 方案',
  '@atlassian/edition-awareness.dialog.free-to-standard.jpd.try-now': '立即試用',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-description': '升級以取得不限數量的客服人員。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-button': '什麼是客服人員？',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-description':
    '客服人員負責處理 Jira Service Management 中的客戶要求。客戶要求可能來自任何使用者。可在 Jira Service Management 中提交要求的使用者人數沒有限制。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-heading':
    '什麼是 Jira Service Management 中的客服人員？',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-popup-link': '深入了解客服人員',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.agent-limits-title':
    '{licensedUserLimit, plural, other {您已邀請 {numberOfUsers} 位客服人員，總共 {licensedUserLimit} 位}}',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.alt': '新增附件',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.increased-storage.title': '更高的儲存空間上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.on-call-management.description':
    '建立自訂的路由規則和向上呈報政策。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.on-call-management.title':
    '待命管理',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.support.description':
    '獲得 Atlassian 專家團隊的支援。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.support.title': '上班時間支援',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.title': 'Standard 方案功能',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.unlimited-email-notifications.description':
    '讓所有人掌握最新的要求活動。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.standard-features.unlimited-email-notifications.title':
    '不限數量的電子郵件通知',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.description':
    '升級至 {standardStorageLimit} GB 的儲存空間以繼續附加檔案',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.title':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.storage-limits.title.aria':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.alt': '新增客服人員',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.carousel.unlimited-creators.title':
    '不限數量的客服人員額度',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.continue': '不需要提高上限',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.description':
    '您正在使用 Free 方案。取得 Standard 方案的 14 天免費試用，以取得不限數量的客服人員額度和額外儲存空間等等。',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.heading': '升級至 Standard 方案',
  '@atlassian/edition-awareness.dialog.free-to-standard.jsm.try-now': '立即試用',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.add-payment-details-button': '新增付款詳細資料',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.premium-content':
    '若要在試用期後繼續使用 Premium 方案，請新增您的付款詳細資料。',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.premium-heading': 'Premium 方案試用',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.standard-content':
    '若要在試用期後繼續使用 Standard 方案，請新增您的付款詳細資料。',
  '@atlassian/edition-awareness.dialog.payment-details-popup.jsw.standard-heading': 'Standard 方案試用',
  '@atlassian/edition-awareness.dialog.premium-add-payment.add-payment': '新增付款詳細資料',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.ai.description':
    '透過人工智慧支援的 ITSM 功能，提供卓越的服務體驗。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.ai.title':
    'Atlassian Intelligence (AI)',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.automation.description':
    '將您的重大事件建立流程自動化。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.automation.title': '進階事件管理',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.support.description':
    '獲得 Atlassian 專家團隊的全天候支援。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.support.title': 'Premium 支援',
  '@atlassian/edition-awareness.dialog.premium-add-payment.carousel.premium-features.title':
    'Premium 方案包含如下進階功能：',
  '@atlassian/edition-awareness.dialog.premium-add-payment.continue': '先繼續',
  '@atlassian/edition-awareness.dialog.premium-add-payment.subtitle':
    '新增付款詳細資料以保留 Premium 功能，並避免功能在試用期結束前被停用。',
  '@atlassian/edition-awareness.dialog.premium-add-payment.title':
    '{trialDaysLeft, plural, other {您的 Premium 試用期將在 {trialDaysLeft,number} 天內結束}}',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.add-payment-details-link':
    '新增付款詳細資料以持續使用 Premium 方案',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.after-trial': '試用之後，我們會將您降級為 Free 方案。',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.end-trial-and-change-plans-link': '結束試用並變更方案',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.explore-premium-features-link': '探索 Premium 方案功能',
  '@atlassian/edition-awareness.dialog.reverse-trial-popup.jsw.heading': '您的 30 天 Premium 方案試用',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.maybe-later': '稍後再說',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.radio-button.best-value': '最佳價值',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.radio-button.buy-now.description':
    '免費獲得前 10 位使用者，持續 2 個月。',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.radio-button.buy-now.heading': '立即購買',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.radio-button.start-trial.description':
    '免費試用 Jira Standard。無須信用卡。',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.radio-button.start-trial.heading': '開始 14 天試用',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.subtitle':
    '若從 Standard 開始，您將獲得無限制的使用者數量，以及超過 10 倍的自動化和儲存空間。',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.title': '不受限制地擴展團隊規模',
  '@atlassian/edition-awareness.dialog.special-offer-sixty.upgrade': '升級',
  '@atlassian/edition-awareness.dialog.standard-add-payment.add-payment': '新增付款詳細資料',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-insights.alt':
    'Confluence 中的頁面深入解析畫面',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-insights.title': '內容深入解析',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-restrictions.alt':
    'Confluence 中的頁面限制畫面',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.content-restrictions.title': '內容限制',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.guest-access.alt':
    'Confluence 中的訪客存取畫面',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.guest-access.title': '訪客存取權',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.unlimited-users.alt':
    '將使用者新增至 Confluence 執行個體',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.confluence.unlimited-users.title':
    '不限數量的使用者',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.add-payment':
    '新增付款詳細資料，以便繼續使用 Standard 方案。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.alt': '新增附件',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.exceeded-free':
    '您已超過 Free 方案的 {freeStorageLimit} GB 儲存空間上限。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.heading':
    '繼續使用 Standard 方案以保留更高的儲存空間上限',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.standard-includes.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.standards-limit':
    'Standard 方案設有 {storageLimit} GB 的儲存空間上限。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.title': '更高的儲存空間上限',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.increased-storage.usage':
    '您已經使用了 <strong>{storageUsed} GB</strong> 的儲存空間',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.custom-roles.description':
    '建立自訂路由規則和向上呈報政策。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.email-notifications.description':
    '讓所有人掌握最新的要求活動。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.email-notifications.title':
    '不限數量的電子郵件通知',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.on-call-management.title':
    '待命管理',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.support.description':
    '獲得 Atlassian 專家團隊的支援。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.support.title': '上班時間支援',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.standard-features.title': 'Standard 方案功能',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.storage-limit-bar.aria':
    '已使用 {storageUsed} GB，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-creators.jpd.heading':
    '{userCount, plural, other {您已邀請 <span>{userCount,number} 位建立者</span>。Free 方案設有 3 位建立者的上限。}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.alt': '新增人員',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.heading':
    'Standard 方案包含進階功能，例如：',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users-image.title':
    '{product, select, jpd {不限數量的建立者} jsm {不限數量的客服人員額度} jira {不限數量的使用者} confluence {不限數量的使用者} other {不限數量的使用者}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.heading':
    '{product, select, jpd {繼續使用 Standard 方案，以保留不限數量的建立者額度} jsm {繼續使用 Standard 方案，以保留不限數量的客服人員} jira {繼續使用 Standard 方案，以保留不限數量的使用者額度} confluence {繼續使用 Standard 方案，以保留不限數量的使用者額度} other {繼續使用 Standard 方案，以保留不限數量的使用者額度}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup':
    '客服人員負責處理 Jira Service Management 中的客戶要求。客戶要求可能來自任何使用者。可在 Jira Service Management 中提交要求的使用者人數沒有限制。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup-link':
    '深入了解客服人員',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm-popup-what-are-agents':
    '什麼是 Jira Service Management 中的客服人員？',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.jsm.heading':
    '{userCount, plural, other {您已邀請 <span>{userCount,number} 位客服人員</span>。Free 方案有 3 位客服人員的上限。<link>什麼是客服人員？</link>}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.carousel.unlimited-users.title':
    '{product, select, jpd {不限數量的建立者} jsm {不限數量的客服人員額度} jira {不限數量的使用者} confluence {不限數量的使用者} other {不限數量的使用者}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.continue': '先繼續',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.custom-roles.description':
    '透過建立具有特定權限的自訂專案角色，進一步掌握細節。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.custom-roles.title':
    '自訂專案角色',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.data-residency.description':
    '選擇要託管資料的位置。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.data-residency.title':
    '資料落地',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.support.description':
    '獲得 Atlassian 專家團隊的支援。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.jpd.carousel.standard-features.support.title':
    '上班時間支援',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.description':
    '您已超過 Free 方案的上限 {dataUsageOverFreeLimitInGB} GB',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.title':
    '已使用 {storageUsed} GB，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.storage-limits.title.aria':
    '您已經使用了 {storageUsed} GB 的儲存空間，總共 {storageLimit} GB',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.description':
    '邀請您的團隊成員和相關人員協作',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.description.near-limit':
    '{userLimitOverFreeLimit, plural, other {您的團隊有 {userLimitOverFreeLimit} 位使用者超過 Free 方案的上限}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.title':
    '充分運用使用者無上限的優勢',
  '@atlassian/edition-awareness.dialog.standard-add-payment.limits-content.user-limits.title.near-limit':
    '您正在發揮使用者無上限的優勢',
  '@atlassian/edition-awareness.dialog.standard-add-payment.subtitle':
    '新增付款詳細資料以保留 Standard 方案的功能，並避免功能在試用期結束前被停用。',
  '@atlassian/edition-awareness.dialog.standard-add-payment.subtitle-trial-days-left':
    '{trialDaysLeft, plural, other {新增付款詳細資料，以在試用結束後保留 Standard 方案的功能。您的試用期將在 {trialDaysLeft} 天後結束。}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.title':
    '{trialDaysLeft, plural, other {您的 Standard 試用期將在 {trialDaysLeft,number} 天內結束}}',
  '@atlassian/edition-awareness.dialog.standard-add-payment.title-take-action': '在試用中採取行動',
  '@atlassian/edition-awareness.dialog.standard-to-premium.compare-features.cta': '比較方案與定價',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jira.text': '全天候支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jira.tooltip':
    '在需要時獲得 Atlassian 專家的支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jpd.text': '全天候支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.jpd.tooltip': '隨時獲得 Atlassian 支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.name': '全天候支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.text': '全天候支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.tooltip': '隨時獲得 Atlassian 支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.24-7-support.value': '隨時獲得 Atlassian 支援',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jira.text': '管理員深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jira.tooltip':
    '追蹤使用者活動、產品使用情況和安全性',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jpd.text': '管理員深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.jpd.tooltip':
    '追蹤使用者活動、產品使用情況和安全性',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.name': '管理員深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.text': '管理員深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.tooltip':
    '追蹤使用者活動、產品使用情況和安全性',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.admin-insights.value':
    '追蹤使用者活動、產品使用情況和安全性',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.advanced-alerts.text': '進階警示',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.advanced-alerts.tooltip':
    '取得警示，協助您更快速解決事件',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.ai.text': 'Atlassian Intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.ai.tooltip': '建立頁面摘要、取得寫作協助等',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.name': '分析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.text': '分析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.tooltip': '取得使用者如何與頁面互動的資料',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.analytics.value': '取得使用者如何與頁面互動的資料',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.name': '資產管理',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.text': '資產管理',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.tooltip':
    '儲存、對應和稽核貴公司的資產庫',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.asset-management.value':
    '儲存、對應和稽核貴公司的資產庫',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.jpd.text':
    'Atlassian Intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.jpd.tooltip':
    '使用人工智慧來摘要意見反應、產生構想並探索深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.name':
    'Atlassian intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.text':
    'Atlassian intelligence',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.tooltip':
    '使用 AI 找出風險、自動化任務和進行編輯',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.atlassian-intelligence.value':
    '使用 AI 找出風險、自動化任務和進行編輯',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.company-hub.text': '公司中心',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.company-hub.tooltip':
    '為所有公司資訊建立單一事實來源',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.name': '跨團隊規劃',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.text': '跨團隊規劃',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.tooltip':
    '在單一位置查看所有專案和時間軸',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.cross-team-planning.value':
    '在單一位置查看所有專案和時間軸',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.deployment-gating.text': '部署調控',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.deployment-gating.tooltip':
    '透過自動化控制來避免有風險的變更',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.hierarchies.jpd.text': '階層',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.hierarchies.jpd.tooltip':
    '查看構想如何對應至策略目標',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.incident-management.text': '事件管理',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.incident-management.tooltip':
    '識別問題、追蹤議題和向上呈報',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.name': '任務控制',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.text': '任務控制',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.tooltip':
    '在單一位置管理權限並取得深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.mission-control.value':
    '在單一位置管理權限並取得深入解析',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.portfolio-roadmaps.jpd.text': '項目組合藍圖',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.portfolio-roadmaps.jpd.tooltip':
    '在一個檢視方式中，統一多個團隊藍圖',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.project-archiving.text': '專案封存',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.project-archiving.tooltip':
    '透過封存非作用中的工作來保持井然有序',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.real-time-incident-monitoring.text': '即時事件監控',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.real-time-incident-monitoring.tooltip':
    '隨時追蹤及管理事件',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.jpd.text': '版本追蹤',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.jpd.tooltip':
    '控制您發布的變更時間和方式',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.text': '版本追蹤',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.release-tracks.tooltip':
    '控制您發布的變更時間和方式',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.roadmap-permissions.value':
    '選擇誰可以查看和編輯構想和藍圖',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.sandbox.text': '沙箱',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.sandbox.tooltip':
    '在進入正式環境前進行安全測試和實驗',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.strategic-goals.value': '查看構想如何對應至策略目標',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.name': '團隊行事曆',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.text': '團隊行事曆',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.tooltip': '規劃各團隊的期限和休假',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-calendar.value': '規劃各團隊的期限和休假',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.team-roadmaps.value':
    '在一個檢視方式中，統一多個團隊藍圖',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.view-restrictions.jpd.text': '檢視限制',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.view-restrictions.jpd.tooltip':
    '控管誰可以檢視和編輯專案檢視',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.name': '虛擬服務客服人員',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.text': '虛擬服務客服人員',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.tooltip':
    '使用 AI 支援的客服人員處理常見議題',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.virtual-service-agents.value':
    '使用 AI 支援的客服人員處理常見議題',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.whiteboards.text': '不限數量的白板',
  '@atlassian/edition-awareness.dialog.standard-to-premium.feature.whiteboards.tooltip':
    '在無限的畫布上進行腦力激盪或建立流程',
  '@atlassian/edition-awareness.dialog.standard-to-premium.heading': '想要更高的額度嗎？歡迎試用 Premium',
  '@atlassian/edition-awareness.dialog.standard-to-premium.highlighted-features.header.text': '免費試用這些功能',
  '@atlassian/edition-awareness.dialog.standard-to-premium.highlighted-features.premium-label.text': 'Premium',
  '@atlassian/edition-awareness.dialog.standard-to-premium.subtitle':
    '免費試用 30 天 Premium 方案的最佳功能。我們會在試用期結束的 3 天前提醒您。您可以隨時取消。',
  '@atlassian/edition-awareness.dialog.standard-to-premium.subtitle.jpd':
    '免費試用 30 天 Premium 方案的最佳功能。我們會在試用期結束的 3 天前提醒您。透過 Premium 方案，您可以：',
  '@atlassian/edition-awareness.dialog.standard-to-premium.try-now.cta': '繼續',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.add-payment-details': '新增付款詳細資料',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.heading': '您已超過免費方案的上限',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.maybe-later': '稍後再說',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.base-limit.title':
    'Free 方案上限 ({freeStorageLimit} GB)',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.confluence.description':
    '在 Free 方案上，您將無法新增頁面。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.jira.description':
    '您在 Free 方案上將無法新增檔案，因為已超過上限。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.storage-limits-info.title':
    '已使用 {storageUsed} GB 儲存空間',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.default':
    '立即新增付款詳細資料，以避免被降級或停用。在試用期結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.inPredunning.storageLimitBreaker':
    '新增付款詳細資料以避免被降級。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.inPredunning.userLimitBreaker':
    '新增付款詳細資料以避免被停用。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.storageLimitBreakerForConfluence':
    '立即新增付款詳細資料，以繼續建立頁面和空間。在試用期於 {trialEndDate}結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.storageLimitBreakerForJira':
    '立即新增付款以繼續上傳檔案和圖片。在試用期於 {trialEndDate}結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.userAndStorageLimitBreaker':
    '立即新增付款詳細資料，以避免被降級或停用。在試用期於 {trialEndDate}結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.subtitle.userLimitBreaker':
    '新增付款詳細資料以避免被停用。在試用期於 {trialEndDate}結束之前，您無須支付費用。',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.description.over-limit':
    '{userLimit, plural, other {在 Free 方案上，您只能保留 {userLimit} 位使用者。}}',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.description.under-limit':
    '邀請您的團隊成員和相關人員協作',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.divider-limit-label':
    '免費上限 ({userLimit})',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.title.over-limit':
    '{licensedUsers, plural, other {已邀請 {licensedUsers} 人}}',
  '@atlassian/edition-awareness.dialog.standard-trial-limit-breakers.user-limits-info.title.under-limit':
    '充分運用使用者無上限的優勢',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.breached-limits.subtitle':
    '您的團隊在升級之前無法新增附件',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.breached-limits.title': '已超過儲存空間上限',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.description-for-jira-admin':
    '升級以獲得更多儲存空間，或<Link>刪除附件</Link>。',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.description-for-non-admin':
    '請與您的管理員連絡，進行升級以獲得更多儲存空間。',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.dismiss': '關閉',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-files': '無限制地上傳文件、檔案和圖片',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-storage':
    '透過 Standard 方案獲得 125 倍的團隊儲存空間',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.feature.more-users':
    '解鎖不限數量的使用者額度、額外安全性等',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.free-limit': 'Free 方案上限',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.free-limit-value': '2 GB',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.standard-limit': 'Standard 方案上限',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.standard-limit-value': '250 GB',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.title':
    '您的團隊已用完免費儲存空間：請升級以獲得更多空間',
  '@atlassian/edition-awareness.dialog.storage-hard-limit-modal.upgrade': '升級',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.premium.description': '探索 Premium 的強大功能。',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.premium.title': 'Premium 試用開始',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.standard.description': '探索 Standard 方案的強大功能。',
  '@atlassian/edition-awareness.dialog.timeline.trial-begins.standard.title': 'Standard 試用開始',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.premium.description':
    '判斷 Premium 方案是否適合您的團隊。',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.standard.description':
    '判斷 Standard 方案是否適合您的團隊。',
  '@atlassian/edition-awareness.dialog.timeline.trial-current-day.title':
    '{trialDaysLeft, plural, other {今天：試用會在 {trialDaysLeft,number} 天後結束}}',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.premium.description':
    '在此日期前採取行動以繼續使用 Premium 方案，或降級為 Free 方案。',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.standard.description':
    '在此日期前採取行動以繼續使用 Standard 方案，或降級為 Free 方案。',
  '@atlassian/edition-awareness.dialog.timeline.trial-ends.title': '試用結束',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link':
    '進一步了解您所適用的 Atlassian 資料隱私權',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1': '您團隊的規模',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2': '您現有的 Atlassian 產品',
  '@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this':
    '我們認為 {offering} 能提高您團隊的生產力。這項建議只會向帳單管理員顯示，依據如下：',
  '@atlassian/edition-awareness.link.add-payment-tooltip': '新增付款詳細資料以保留您的訂閱',
  '@atlassian/edition-awareness.link.jira-standard-trial-overview-tooltip': '進一步了解您的試用和付款方式',
  '@atlassian/edition-awareness.link.payment-flow-tooltip': '新增付款詳細資料以保留您的訂閱',
  '@atlassian/edition-awareness.spotlight.message': '還沒準備好要升級嗎？準備好後返回您的個人資料。',
  '@atlassian/edition-awareness.spotlights.got-it': '了解',
  '@atlassian/edition-awareness.upgrade-complete-flag.action': '重新整理',
  '@atlassian/edition-awareness.upgrade-complete-flag.description2':
    '{edition, select, standard {{product, select, confluence {您的 Confluence Standard 升級已完成。} jira {您的 Jira Standard 升級已完成。} jpd {您的 Jira Product Discovery Standard 升級已完成。} jsm {您的 Jira Service Management Standard 升級已完成。} other {您的 Standard 升級已完成。}}} premium {{product, select, confluence {您的 Confluence Premium 升級已完成。} jira {您的 Jira Premium 升級已完成。} jpd {您的 Jira Product Discovery Premium 升級已完成。} jsm {您的 Jira Service Management Premium 升級已完成。} other {您的 Premium 升級已完成。}}} other {{product, select, confluence {您的 Confluence 升級已完成。} jira {您的 Jira 升級已完成。} jpd {您的 Jira Product Discovery 升級已完成。} jsm {您的 Jira Service Management 升級已完成。} other {您的升級已完成。}}}}',
  '@atlassian/edition-awareness.upgrade-complete-flag.title': '重新整理以開始使用新功能',
  '@atlassian/edition-awareness.upgrade-in-progress-flag.description': '這可能需要幾分鐘的時間。完成後，我們會通知您。',
  '@atlassian/edition-awareness.upgrade-in-progress-flag.title': '正在升級您的方案',
  'trial-components.action.menu.downgrade.message.v2': '試用之後，我們會將您降級為 Free 方案。',
  'trial-components.add.payment.premium.button': '新增付款詳細資料以持續使用 Premium 方案',
  'trial-components.end.trial.button': '結束試用並變更方案',
  'trial-components.explore.premium.button': '探索 Premium 方案功能',
  'trial-components.premium.charge-message': '當您的試用期在 {trialEndDate} 結束時，會需要支付 Premium 每月費用。',
  'trial-components.premium.feature-highlight-description.toggle': '我們會透過標籤協助您識別 Premium 功能。',
  'trial-components.premium.feature-highlight-title.toggle': '醒目顯示 Premium 功能',
  'trial-components.premium.review-feature-guide.button': '回顧功能指南',
  'trial-components.premium.trial.title': 'Premium 方案試用',
  'trial-components.see.billing.button': '查看帳單詳細資料',
};
